import {makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    backgroundColor: theme.palette.primary.main,
  },
  container:{
    flexDirection: 'column'
  },
  center:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    padding: `${theme.spacing(4)}px ${theme.spacing(1.5)}px`,
    minWidth: 270,
    maxWidth: 416
  },
  formTitle: {
    marginBottom: theme.spacing(1)
  },
  logoContainer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  welcome: {
    textAlign: 'center',
    color: 'var(--sub-text-color)',
    fontSize: 16
  },
  logo: {
    width: '100%'
  },
}));

export default useStyles
